import { getStore } from '~/mobx/AppStore';

const getSelectedCandidate = () => {
    const { candidateStore } = getStore();
    const selectedCandidate = candidateStore.selectedCandidateId
        ? candidateStore.candidates.find((candidate) => candidate.id === candidateStore.selectedCandidateId)
        : undefined;
    return selectedCandidate;
};

export default getSelectedCandidate;
